<template>
    <div v-if="requiredQualifications && qualificationgroups" class="row mb-1" v-for="requiredQualification in requiredQualifications">
        <input type="hidden" class="qualificationarray" name="qualifications[]" :value="requiredQualification">
        <div class="col-2">
            <input class="form-control" type="text" :value="getQualification(requiredQualification)?.qualificationgroup.name" readonly>
        </div>
        <div class="col-2">
            <input class="form-control" type="text" :value="getQualification(requiredQualification)?.name" readonly>
        </div>
        <div class="col-2 p-2 text-center">
            <i class="fa fa-trash text-danger" @click="removeQualification(requiredQualification)"></i> 
        </div>
    </div>

    <div class="row">
        <div class="col-2">
            <select v-if="qualificationgroups" class="form-control" v-model="qualification_group_id"
                id="qualification_group_id">
                <option :value="0" selected>{{ $trans.get("__JSON__.Choose qualification group") }}</option>
                <option v-for="item in qualificationgroups" :key="item.id" :value="item.id">
                    {{ item.name }}
                </option>
            </select>
        </div>
        <div class="col-2">
            <select v-if="qualification_group_id > 0" class="form-control" v-model="qualification_id"
                id="qualification_group_id">
                <option :value="0" selected>{{ $trans.get("__JSON__.Choose qualification") }}</option>
                <option v-for="item in qualifications" :key="item.id" :value="item.id">
                    {{ item.name }}
                </option>
            </select>

        </div>
        <div class="col-2 text-center">
            <a href="#" class="btn btn-primary" @click.prevent="addQualification">{{ $trans.get('__JSON__.Add qualification') }}</a>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import getQualificationGroups from "../composables/getQualificationGroups";

export default {
    setup(props) {
        const { qualificationgroups, qualificationgroups_error, loadQualificationGroups } = getQualificationGroups();
        loadQualificationGroups();

        console.log('Existing: ', props.existingqualifications )
        return { qualificationgroups };
    },
    name: "ProjectQualifications",
    created() {
        this.requiredQualifications = this.existingqualifications ?? [];
    },
    props: {
        existingqualifications: Array
    },
    data() {
        return {
            qualification_group_id: 0,
            qualification_id: 0,
            requiredQualifications: []
        };
    },
    computed: {
        qualifications() {
            if (qualification_group_id == 0) {
                return null;
            }

            const qualificationgroup = [...this.qualificationgroups].find((item) => item.id == this.qualification_group_id);
            return qualificationgroup.qualifications;
        }
    },
    mounted() {
    },
    methods: {
        getQualification(qualification_id) {
            for (let qualificationGroup of this.qualificationgroups) {
                const qualification = qualificationGroup.qualifications.find((item) => item.id == qualification_id);
                if (qualification) {
                    qualification.qualificationgroup = qualificationGroup;
                    return qualification;
                }
            }
            return null;
        },
        addQualification() {
            this.requiredQualifications.push(this.qualification_id);
            this.qualification_group_id = 0;
            this.qualification_id = 0;
        },
        removeQualification (qualificationId ) {
            const index = this.requiredQualifications.indexOf(qualificationId);
            if (index > -1) {
                this.requiredQualifications.splice(index, 1); // 2nd parameter means remove one item only
            }
        }
    }
};
</script>

<style scoped></style>
